import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-delete-all-chores-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Delete All Chores</h2>
    <mat-dialog-content>
      <p>Are you sure you want to delete <strong>ALL</strong> chores? This action cannot be undone.</p>
      <p>This is a temporary feature for testing purposes only.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="warn" (click)="confirmDelete()">Delete All</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      margin-bottom: 20px;
    }
    
    button {
      margin-left: 8px;
    }
  `]
})
export class DeleteAllChoresDialogComponent {
  constructor(private dialogRef: MatDialogRef<DeleteAllChoresDialogComponent>) {}

  confirmDelete(): void {
    this.dialogRef.close(true);
  }
}
